import axios from '../Axios/Default';
import { handleResponse, getMultipartOptions } from './HelperService';

const getMenus = (params, onSuccess, onError) => {
    const response = axios.get(`/api/v1/admin/menu`, {params});
    return handleResponse(response, onSuccess, onError);
};

const getHierarchy = (params, onSuccess, onError) => {
    const response = axios.get(`/api/v1/admin/menu/hierarchy`, {params});
    return handleResponse(response, onSuccess, onError);
};

const getMenuById = (id, onSuccess, onError) => {
    const response = axios.get(`api/v1/admin/menu/${id}`);
    return handleResponse(response, onSuccess, onError);
};

const createMenu = (payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/menu`, payload, getMultipartOptions(axios));
    return handleResponse(response, onSuccess, onError);
};

const updateMenu = (id, payload, onSuccess, onError) => {
    const response = axios.post(`api/v1/admin/menu/${id}`, payload, getMultipartOptions(axios));
    return handleResponse(response, onSuccess, onError);
};

const softDeleteMenu = (id, payload, onSuccess, onError) => {
    const response = axios.put(`api/v1/admin/menu/${id}/delete`, payload);
    return handleResponse(response, onSuccess, onError);
};

export { getMenus, getMenuById, createMenu, updateMenu, softDeleteMenu, getHierarchy };